import React, { useContext } from "react";
import { Formik, Form, Field, getIn, ErrorMessage } from "formik";
import * as Yup from "yup";

import DispatchContext from "../../contexts/DispatchContext";
import DataFetcher from "../../utils/DataFetcher";
import { dispError, dispSuccess } from "../../utils/Tools";
import ErrorLine from "../elements/ErrorLine";

function FormSendRequest(props) {
  const appDispatch = useContext(DispatchContext);

  const validation = Yup.object().shape({
    subject: Yup.string().required("Bitte geben Sie einen Betreff ein."),
    message: Yup.string().required("Bitte geben Sie eine Nachricht ein.")
  });

  const defaultValues = {
    subject: "Kompetenzcheck21",
    message: ""
  };

  const targetURL = "/message/send";
  const onSubmit = (values, { resetForm, setSubmitting }) => {
    let payload = { ...values };
    DataFetcher.fetch(targetURL, payload)
      .then(response => {
        if (!response.success) {
          setSubmitting(false);
          return appDispatch(dispError(response.msg));
        }
        appDispatch(dispSuccess(response.msg));
        resetForm({ values: "" });
      })
      .catch(error => {
        console.error(error);
        setSubmitting(false);
      });
  };

  return (
    <Formik initialValues={defaultValues} validationSchema={validation} onSubmit={onSubmit}>
      {({ errors, touched, isSubmitting }) => (
        <Form autoComplete="off">
          <div className="field">
            <label className="label">Betreff*</label>
            <div className="control">
              <Field name="subject" type="text" className={`input${getIn(touched, "subject") && getIn(errors, "subject") ? " is-danger" : ""}`} />
            </div>
            <ErrorMessage component={ErrorLine} name="subject" />
          </div>

          <div className="field">
            <label className="label">Nachricht*</label>
            <div className="control">
              <Field component="textarea" rows={4} name="message" className={`textarea${getIn(touched, "message") && getIn(errors, "message") ? " is-danger" : ""}`} />
            </div>
            <ErrorMessage component={ErrorLine} name="message" />
          </div>

          <div className="field">
            <div className="control field-body">
              <button className="button is-success" type="submit" disabled={isSubmitting}>
                Absenden
              </button>
              <button className="button ml-2" type="button" onClick={props.onCancel}>
                Abbrechen
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}
export default FormSendRequest;
